import React from 'react'
import { Icon } from '@chakra-ui/react'

const CircleIcon1 = ({ ...props }) => {
  return (
    <Icon
      width="65"
      height="122"
      viewBox="0 0 65 122"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        cx="61"
        cy="61"
        r="58.5"
        fill="#83B53C"
        stroke="white"
        stroke-width="5"
      />
    </Icon>
  )
}

export default CircleIcon1
